import Vue from "vue";
import Router from "vue-router";
import config from "@/router/globalConfig";
import Login from "@/components/Login";
import License from "@/components/License";
import Master from "@/components/Master";
import Home from "@/components/Home";
import SessionExpire from "@/components/SessionExpire";
import Registration from "@/components/Registration";
import StatusSummary from "@/components/StatusSummary";
import FileDrive from "@/components/FileDrive";
import UploadDownloadStatus from "@/components/UploadDownloadStatus";
import UploadTest from "@/components/UploadTest";
Vue.use(Router)

const router= new Router({
  routes: [    
    { path: "/", name: "Login", component: Login },
    //{ path: "/", name: "HashTest", component: HashTest },
    { path: "/License", name: "License", component: License },
    { path: "/SessionExpire", name: "SessionExpire", component: SessionExpire },    
    {
      path: "/Master", name: "Master", component: Master, children: [
        { path: "/Home", name: "Home", component: Home },
        { path: "/Registration", name: "Registration", component: Registration },
        { path: "/StatusSummary", name: "StatusSummary", component: StatusSummary },
        { path: "/FileDrive", name: "FileDrive", component: FileDrive },
        { path: "/UploadDownloadStatus", name: "UploadDownloadStatus", component: UploadDownloadStatus },
        { path: "/UploadTest", name: "UploadTest", component: UploadTest },
      ]
    }
  ]
});
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((error) => {
  });
};
router.beforeEach((to, from, next) => {     
  if(to.name=="Login" || to.name=="License" || to.name=="SessionExpire" || to.name=="Home"){
    next();
  }
  else if(config.CurrentUser!=undefined && config.CurrentUser.userTypeRights.filter(s=>s[0]==config.CurrentUser.userTypeID && s[1]==to.name).length>0){
    next();
  }
  else{
    next({ name: from.name });
  }
 });
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js